import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginUserApi } from "../../../apiclient/authapi/Auth-api";
import { LoginCognitoModel, LoginModel } from "../../../features/authentication/model";

///async thunk to login user
export const LoginUser = createAsyncThunk("LoginUser", async (user: LoginCognitoModel) => {
    return await LoginUserApi(user);
});


